"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var toggle_class_1 = require("ally.js/util/toggle-class");
var shadow_focus_1 = (0, tslib_1.__importDefault)(require("ally.js/event/shadow-focus"));
var interaction_type_1 = (0, tslib_1.__importDefault)(require("ally.js/observe/interaction-type"));
// preferring focusin/out because they are synchronous in IE10+11
var supportsFocusIn = typeof document !== 'undefined' && 'onfocusin' in document;
var focusEventName = supportsFocusIn ? 'focusin' : 'focus';
var blurEventName = supportsFocusIn ? 'focusout' : 'blur';
// interface to read interaction-type-listener state
var interactionTypeHandler;
var shadowHandle;
// keep track of last focus source
var current = null;
// overwrite focus source for use with the every upcoming focus event
var lock = null;
// keep track of ever having used a particular input method to change focus
var used = {
    pointer: false,
    key: false,
    script: false,
    initial: false,
};
function handleFocusEvent(target, event) {
    if (target === void 0) { target = document.documentElement; }
    var source = '';
    if (event.type === focusEventName || event.type === 'shadow-focus') {
        var interactionType = interactionTypeHandler.get();
        source =
            lock ||
                (interactionType.pointer && 'pointer') ||
                (interactionType.key && 'key') ||
                'script';
    }
    else if (event.type === 'initial') {
        source = 'initial';
    }
    target.setAttribute('data-focus-source', source);
    if (event.type !== blurEventName) {
        if (!used[source]) {
            (0, toggle_class_1.addClass)(target, 'focus-source-' + source);
        }
        used[source] = true;
        current = source;
    }
}
function getCurrentFocusSource() {
    return current;
}
function getUsedFocusSource(source) {
    return used[source];
}
function lockFocusSource(source) {
    lock = source;
}
function unlockFocusSource() {
    lock = false;
}
function disengage(target) {
    var handleFocusEventWithTarget = (function (el) { return function (event) {
        return handleFocusEvent(el, event);
    }; })(target);
    // clear dom state
    handleFocusEventWithTarget({ type: blurEventName });
    current = lock = null;
    Object.keys(used).forEach(function (key) {
        (0, toggle_class_1.removeClass)(target, 'focus-source-' + key);
        used[key] = false;
    });
    // kill interaction type identification listener
    interactionTypeHandler.disengage();
    // kill shadow-focus event dispatcher
    shadowHandle && shadowHandle.disengage();
    document.removeEventListener('shadow-focus', handleFocusEventWithTarget, true);
    target.removeEventListener(focusEventName, handleFocusEventWithTarget, true);
    target.removeEventListener(blurEventName, handleFocusEventWithTarget, true);
    target.removeAttribute('data-focus-source');
}
function engage(target) {
    var handleFocusEventWithTarget = (function (el) { return function (event) {
        return handleFocusEvent(el, event);
    }; })(target);
    // enable the shadow-focus event dispatcher
    shadowHandle = (0, shadow_focus_1.default)();
    // handlers to modify the focused element
    document.addEventListener('shadow-focus', handleFocusEventWithTarget, true);
    target.addEventListener(focusEventName, handleFocusEventWithTarget, true);
    target.addEventListener(blurEventName, handleFocusEventWithTarget, true);
    // enable the interaction type identification observer
    interactionTypeHandler = (0, interaction_type_1.default)();
    // set up initial dom state
    handleFocusEventWithTarget({ type: 'initial' });
    return {
        used: getUsedFocusSource,
        current: getCurrentFocusSource,
        lock: lockFocusSource,
        unlock: unlockFocusSource,
    };
}
exports.default = { engage: engage, disengage: disengage };
//# sourceMappingURL=focus-source.js.map